import type { DaysOfWeek, ScheduleTimeBasedPattern } from '@/enum'
import type { ITimeBasedTrigger } from '@/interfaces/jobs/ITimeBasedTrigger'

class TimeBasedTrigger implements ITimeBasedTrigger {
  pattern: ScheduleTimeBasedPattern | null
  startFrom: string | null
  daysOfWeek: DaysOfWeek[]
  daysOfMonth: number[]
  dates: string[]
  repeatAfterEvery: number | null

  constructor(timeBasedTrigger?: any) {
    this.pattern =
      timeBasedTrigger?.pattern == undefined || timeBasedTrigger?.pattern == null
        ? null
        : timeBasedTrigger?.pattern
    this.startFrom = timeBasedTrigger?.startFrom ?? null
    this.daysOfWeek = timeBasedTrigger?.daysOfWeek || []
    this.daysOfMonth = timeBasedTrigger?.daysOfMonth || []
    this.dates = timeBasedTrigger?.dates || ''
    this.repeatAfterEvery = timeBasedTrigger?.repeatAfterEvery
  }
}

export default TimeBasedTrigger
